import Modal from '../addons/micro-modal';
import { slideToggle } from './startup/slide';
import { getCategoryFromGroup } from './utils/ga4-tracking/custom-dimensions';
import { pushToDataLayer } from './utils/ga4-tracking/push-to-data-layer';
import { resizeTable } from './utils/utils';
import rangeSlider from './forms/range-slider';
import { textInput } from './forms/form-input';
import { setCookie } from './startup/cookies-helper';

// code for styleguide inputs
document.querySelectorAll('.otto-form-element').forEach(elem => textInput(elem));

//init rangesliders
document.querySelectorAll('input[type=range]').forEach(elem => rangeSlider(elem));

// Tariff Overview

document.addEventListener(
  'click',
  e => {
    if (!e.target.classList.contains('btn') && !e.target.classList.contains('more')) {
      let box = document.querySelector('.box.show-more');
      if (box) {
        box.classList.remove('show-more');
      }
    }
  },
  false
);

document.querySelectorAll('.tariffOverview-block .box .more').forEach(elem => {
  elem.addEventListener('click', e => {
    e.preventDefault();
    elem.parentNode.classList.add('show-more');
  });
});

// Mockup tabs

document.querySelectorAll('.mockupTabs-block .tabs-menu li a').forEach(elem => {
  let block = elem.closest('.mockupTabs-block');
  elem.addEventListener('click', e => {
    e.preventDefault();

    block.querySelector('.tabs-menu li.active').classList.remove('active');
    elem.parentNode.classList.add('active');

    block.querySelector('.mockup-iphone.active').classList.add('hide');

    setTimeout(() => {
      block.querySelector('.mockup-iphone.active').classList.remove('active', 'hide');
      block.querySelector('.mockup-iphone.' + elem.getAttribute('data-tab-link').substring(1)).classList.add('active', 'hide');
      setTimeout(() => {
        block.querySelector('.mockup-iphone.active').classList.add('show');
        setTimeout(() => {
          block.querySelector('.mockup-iphone.active').classList.remove('hide', 'show');
        }, 500);
      }, 100);
    }, 500);
  });
});

// Feature tabs

document.querySelectorAll('#feature-overview header nav li a').forEach(navItem => {
  let block = navItem.closest('#feature-overview');
  navItem.addEventListener('click', e => {
    e.preventDefault();

    let id = navItem.getAttribute('href');

    block.querySelector('header nav li.active').classList.remove('active');
    navItem.parentNode.classList.add('active');

    block.querySelector('.phone > div.active').classList.remove('active');
    block.querySelector(id).classList.add('active');
  });
});

// Modal
Modal.init({
  onShow: modal => {
    modal.dispatchEvent(new CustomEvent('modalShow'));
  },
  onClose: modal => {
    modal.dispatchEvent(new CustomEvent('modalClose'));
  },
  disableScroll: true,
  openTrigger: 'data-modal',
  closeTrigger: 'data-close'
});

//triggerChat on mobile
document.querySelectorAll('.triggerChat').forEach(elem => {
  elem.addEventListener('click', e => {
    e.preventDefault();
    document.querySelector('body > otto-support-chat')?.shadowRoot?.querySelector('div > otto-support-chat-button')?.shadowRoot?.querySelector('button')?.click();
    if (!elem.classList.contains('accessibility-chat')) {
      setTimeout(() => {
        const navigationToggle = document.querySelector('#header .navigation-toggle');
        // only close the mobile nav – clicking while it is closed (e.g. from the consultation modal) would open it over the page
        if (navigationToggle.classList.contains('active')) {
          navigationToggle.click();
        }
      }, 500);
    }
  });
});

const getParamModalId = () => {
  //URL Parameters Modals
  const urlParams = new URLSearchParams(window.location.search);
  const trackingEvent = {
    element_section: 'doi_element'
  };
  if (urlParams.has('insurance_group')) {
    trackingEvent.insurance_group = urlParams.get('insurance_group');
    trackingEvent.insurance_category = getCategoryFromGroup(urlParams.get('insurance_group'));
  }
  if (urlParams.has('job_status')) {
    trackingEvent.job_status = urlParams.get('job_status');
  }

  if (urlParams.has('confirmed-appointment')) {
    pushToDataLayer({
      ...trackingEvent,
      event: 'sales_appointment',
      appointment_status: 'validated',
      appointment_class: 'initial'
    });
    return 'confirm-appointment-modal';
  } else if (urlParams.has('expired-appointment')) {
    setCookie('doi_expired', 'true');
    pushToDataLayer({
      ...trackingEvent,
      event: 'sales_appointment',
      appointment_status: 'expired',
      appointment_class: 'initial'
    });
    return 'expired-appointment-modal';
  } else if (urlParams.has('confirmed') || urlParams.has('confirmed-en')) {
    if (en || urlParams.has('confirmed-en')) {
      return 'confirm-modal-en';
    }
    return 'confirm-modal-de';
  } else if (urlParams.has('consultation')) {
    return 'consultation-modal';
  } else if (urlParams.has('unsubscribed')) {
    return 'unsubscribe-modal';
  } else if (urlParams.has('chatDown')) {
    return 'chat-modal';
  }
  return false;
};
const paramModal = getParamModalId();
if (paramModal && document.querySelector(`#${paramModal}`)) {
  Modal.show(paramModal, { disableScroll: true, closeTrigger: 'data-close' });
}

// Table Height

function resizeListEntries() {
  document.querySelectorAll('.tariffTable-block,.elab-tariffTable-block').forEach(block => {
    resizeTable(block.querySelector('table'));
  });
}

window.addEventListener('customLoaded', resizeListEntries);
window.addEventListener('resize', resizeListEntries);
window.addEventListener('setStickyNavigationTab', resizeListEntries);

// Table selects

function setTableSelectReplace(block, select) {
  let option = select.options[select.selectedIndex],
    data = Object.assign({}, option.dataset);

  for (let key in data) {
    block.querySelectorAll('span[data-select="' + select.dataset.select + '"][data-key="' + key + '"]').forEach(span => {
      span.textContent = data[key];
    });
  }
}

function setTableSelect() {
  document.querySelectorAll('.benefits-table-24,.tariffTable-block,.elab-tariffTable-block').forEach(block => {
    block.querySelectorAll('select[data-select]').forEach(select => {
      setTableSelectReplace(block, select);
      select.addEventListener('change', e => {
        setTableSelectReplace(block, select);
      });
    });
  });
}

window.addEventListener('customLoaded', setTableSelect);

// FAQ

document.querySelectorAll('.faq-block .entry, .accordion-block .item').forEach(elem => {
  const button = elem.querySelector('button');
  if (!button) {
    return;
  }
  button.addEventListener('click', e => {
    elem.classList.toggle('active');
    slideToggle(elem.querySelector('.content'));
    button.setAttribute('aria-expanded', elem.classList.contains('active'));
  });
});

//Hero Accordion
document.querySelectorAll('.hero-accordion-block .item').forEach(elem => {
  elem.querySelector('button').addEventListener('click', e => {
    if (!elem.classList.contains('active')) {
      slideToggle(document.querySelector('.hero-accordion-block .item.active .content'));
      document.querySelector('.hero-accordion-block .item.active').classList.remove('active');
      elem.classList.add('active');
      slideToggle(elem.querySelector('.content'));
    }
  });
});

// ABC-block
const mediaQuery = window.matchMedia('(min-width: 992px)');
document.querySelectorAll('.abc-block .entry').forEach(entry => {
  entry.addEventListener('click', e => {
    if (mediaQuery.matches) {
      return;
    }
    entry.classList.toggle('active');
    slideToggle(entry.querySelector('.entry-content'));
  });
});

// Footer

document.querySelectorAll('#footer .navigation .box nav').forEach(elem => {
  const button = elem.querySelector('button');
  if (!button) {
    return;
  }
  button.addEventListener('click', e => {
    elem.classList.toggle('active');
    slideToggle(elem.querySelector('ul'));
    button.setAttribute('aria-expanded', elem.classList.contains('active'));
  });
});

// User Centrics Data Privacy Window Trigger
document.querySelectorAll('.uc-privacy-setting').forEach(elem => {
  elem.addEventListener('click', e => {
    e.stopPropagation();
    e.preventDefault();
    __ucCmp.showSecondLayer();
  });
});

// File list download icon

document.querySelectorAll('.btn-download').forEach(elem => {
  const svg = elem.querySelector('.dlanim');
  if (typeof svg != 'undefined' && svg != null) {
    elem.addEventListener('click', e => {
      svg.classList.add('loaded');
    });
  }
});

// Magazine Data Links

document.querySelectorAll('div.data-link').forEach(elem => {
  elem.addEventListener('click', e => {
    e.stopPropagation();
    e.preventDefault();
    window.location.href = elem.dataset.link;
  });
});

// Keyfigures & APP Preview - time in mockup

document.querySelectorAll('.keyfigures-v2-block, .app-preview-block, .trust-block-v2').forEach(block => {
  const timeFields = block.querySelectorAll('.phone-time');

  function currentTime() {
    const date = new Date();
    const en = document.documentElement.lang === 'en';
    const optionsTime = { hour: 'numeric', minute: 'numeric' };
    timeFields.forEach(elem => {
      elem.innerText = date
        .toLocaleTimeString(en ? 'en-US' : 'de-DE', optionsTime)
        .replace(' ', '')
        .replace('AM', '')
        .replace('PM', '');
    });
  }

  currentTime();
  setInterval(currentTime, 5000);
});

const is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
const is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome/') > -1;

if (window.innerWidth > 993 && (!is_safari || is_chrome)) {
  console.log(
    '╔══════════════════════════════════════════════════════════════════════════╗\n║..WELCOME TO .............................................................║\n║..██████╗.████████╗████████╗.██████╗.███╗...██╗.██████╗.██╗...██╗.█████╗..║\n║.██╔═══██╗╚══██╔══╝╚══██╔══╝██╔═══██╗████╗..██║██╔═══██╗██║...██║██╔══██╗.║\n║.██║...██║...██║......██║...██║...██║██╔██╗.██║██║...██║██║...██║███████║.║\n║.██║...██║...██║......██║...██║...██║██║╚██╗██║██║...██║╚██╗.██╔╝██╔══██║.║\n║.╚██████╔╝...██║......██║...╚██████╔╝██║.╚████║╚██████╔╝.╚████╔╝.██║..██║.║\n║..╚═════╝....╚═╝......╚═╝....╚═════╝.╚═╝..╚═══╝.╚═════╝...╚═══╝..╚═╝..╚═╝.║\n║....................................OTTONOVA.TECH WISHES A PLEASANT STAY..║\n╚══════════════════════════════════════════════════════════════════════════╝'
  );
} else {
  console.log('════ WELCOME TO OTTONOVA.TECH ════');
}
